import type { PublicLeaderboard } from '../../lib/shooting';

/** Public results use the published Round 2 totals without combining rounds. */
export function PublicRound2Results({ round2 }: { round2: NonNullable<PublicLeaderboard['round2']> }) {
  return (
    <section id="round2-public" aria-label="Round 2 results" className="@container min-w-0 space-y-5">
      <div>
        <h2 className="text-xl font-bold text-white sm:text-2xl">Round 2</h2>
        <p className="mt-1 text-sm text-slate-400">Ranked by the Round 2 team score.</p>
      </div>
      {round2.teams.length === 0 ? <p className="py-8 text-slate-400">No Round 2 team scores are available yet.</p> : (
        <ol aria-label="Round 2 team standings" className="grid items-start gap-4 @2xl:grid-cols-2 @5xl:grid-cols-3">
          {round2.teams.map((team) => (
            <li key={team.teamId} data-round2-card className="min-w-0 overflow-hidden rounded-[var(--radius-lg)] border border-white/10 bg-white/[0.03]">
              <div className="flex items-start justify-between gap-4 border-b border-white/10 bg-white/[0.03] p-4">
                <div className="min-w-0">
                  <p className="mb-1 text-xs font-semibold uppercase tracking-wider text-slate-400">{team.rank ? `Rank ${team.rank}` : 'Unranked'}</p>
                  <h3 className="break-words text-lg font-semibold leading-snug text-white">{team.name}</h3>
                </div>
                <div className="shrink-0 text-right">
                  <p className="mb-1 text-xs text-slate-400">Team score</p>
                  <strong className="block text-2xl font-bold tabular-nums text-amber-200">{team.totalDisplay}</strong>
                </div>
              </div>
              {team.members.length === 0 ? <p className="p-4 text-sm text-slate-400">No shooters yet.</p> : (
                <div className="p-4">
                  <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-400">Shooter scores</p>
                  <ul className="divide-y divide-white/[0.06] text-sm text-slate-200">
                    {team.members.map((member) => (
                      <li key={member.shooterId} className="flex items-start justify-between gap-4 py-2 first:pt-0 last:pb-0">
                        <span className="min-w-0 break-words">{member.name}</span>
                        <span className="shrink-0 font-semibold tabular-nums text-white">{member.totalDisplay}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
